<template>
  <q-page padding>
    <div class="row col-12 align">
      <p class="text-h6 text-brand-1 text-weight-bold">
        Criar Pedidos de Compras
      </p>
    </div>
    <div class="q-ml-md">
      <div class="row col-12 q-mt-md">
        <div
          style="font-size: 16px"
          class="q-mb-sm text-brand-1 text-weight-medium"
        >
          <span>Digite razão social, fantasia ou CNPJ.</span>
        </div>
        <div class="row col-12 q-gutter-sm">
          <div class="col-3">
            <SelectEmpresas v-model="empresa" />
          </div>
        </div>
      </div>
      <section class="row col-12 q-mt-xl text-brand-1 text-weight-bold">
        <div
          style="font-size: 16px"
          class="q-mb-sm text-brand-1 text-weight-medium"
        >
          <span>Complete as informações iniciais do pedido.</span>
        </div>
        <div class="row col-12 q-gutter-sm">
          <div class="col-md-3">
            <div class="q-ml-sm">Unidade</div>
            <lista-unidades-select v-model="unidade"></lista-unidades-select>
          </div>
          <div class="col-2">
            <div class="q-ml-sm">Data de Emissão</div>
            <q-input mask="##/##/####" dense outlined v-model="emissao">
              <template v-slot:append>
                <q-icon
                  color="brand-1"
                  name="sym_o_calendar_month"
                  class="cursor-pointer"
                >
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="emissao"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <div class="col-2">
            <div class="q-ml-sm">Previsão de Faturamento</div>
            <q-input mask="##/##/####" dense outlined v-model="faturamento">
              <template v-slot:append>
                <q-icon
                  color="brand-1"
                  name="sym_o_calendar_month"
                  class="cursor-pointer"
                >
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="faturamento"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <div class="col-2">
            <div class="q-ml-sm">Previsão de Recebimento</div>
            <q-input
              dense
              outlined
              v-model="recebimento"
              mask="##/##/####"
              :rules="[(val) => !!val || 'Este campo é obrigatório']"
            >
              <template v-slot:append>
                <q-icon
                  color="brand-1"
                  name="sym_o_calendar_month"
                  class="cursor-pointer"
                >
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="recebimento"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </section>

      <q-btn
        @click="criar"
        class="q-mt-xl"
        icon="add"
        no-caps
        style="border-radius: 8px; background-color: #304f78; color: white"
        label="Criar Novo Pedido de Compra"
        :disable="!recebimento"
      />
    </div>
  </q-page>
</template>

<script>
// import EmpresasTable from "../components/EmpresasTable.vue";
import { ref, onMounted } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelectEmpresas from "../components/SelectEmpresas.vue";
export default {
  components: { ListaUnidadesSelect, SelectEmpresas },
  setup() {
    const empresa = ref("");
    const router = useRouter();
    const emissao = ref("");
    const faturamento = ref("");
    const recebimento = ref("");
    const erroRecebimento = ref(false);
    const $q = useQuasar();
    const store = useStore();
    const unidade = ref();
    // const empresa = ref("")

    const receberEmpresa = async (value) => {
      empresa.value = value;
    };

    const criar = async () => {
      if (!recebimento.value) {
        erroRecebimento.value = true;
        return;
      }
      erroRecebimento.value = false;

      try {
        const response = await store.dispatch("compras/criarPedido", {
          billing_date_forecast: faturamento.value,
          issue_date: emissao.value,
          provider_id: empresa?.value?.id,
          receipt_date_forecast: recebimento.value,
          vendor_id: store.state.org.unidadeData.id,
        });

        $q.notify({
          message: "Criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        router.push({
          name: "compras-editar",
          params: { id: response.data.model.id },
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      receberEmpresa,
      empresa,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      emissao,
      faturamento,
      criar,
      recebimento,
      erroRecebimento,
      unidade,
    };
  },
};
</script>

<style></style>
